import { Facebook, Instagram, Linkedin } from "lucide-react";

const socials = [
  { icon: Facebook, href: "https://www.facebook.com/cobimeccanica", label: "Facebook" },
  { icon: Instagram, href: "https://www.instagram.com/cobimeccanica/", label: "Instagram" },
  { icon: Linkedin, href: "https://www.linkedin.com/company/cobimeccanicasrl/", label: "LinkedIn" },
];

export const Footer = () => (
  <footer data-testid="footer" className="border-t border-white/10 bg-zinc-950">
    <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-16">
      <div className="font-display font-black uppercase text-[13vw] md:text-[10vw] leading-[0.8] tracking-tighter text-zinc-900 select-none mb-12">
        Cobi Meccanica
      </div>

      <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-8 border-t border-white/10 pt-8">
        <div className="flex items-center gap-2">
          <span className="w-2.5 h-2.5 bg-red-600" />
          <span className="font-display font-extrabold uppercase tracking-tight">Cobi Meccanica S.r.l.</span>
        </div>

        <div className="flex gap-4">
          {socials.map((s) => {
            const Icon = s.icon;
            return (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                data-testid={`social-${s.label.toLowerCase()}`}
                className="w-11 h-11 border border-white/15 flex items-center justify-center text-zinc-400 hover:bg-red-600 hover:border-red-600 hover:text-white transition-colors"
              >
                <Icon size={18} />
              </a>
            );
          })}
        </div>
      </div>

      <div className="mt-8 font-mono text-[11px] uppercase tracking-wider text-zinc-600 flex flex-col md:flex-row gap-2 md:gap-6">
        <span>P.IVA 01618480360</span>
        <span>R.E.A. MO-230418</span>
        <span>Cap. Soc. € 30.000,00</span>
        <span className="md:ml-auto">© {new Date().getFullYear()} Cobi Meccanica S.r.l.</span>
      </div>
    </div>
  </footer>
);
